module.exports = __webpack_public_path__ + "img/more-icon.7dae6833.svg";